/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Tracking_Mode_LotInputs */

const vi_packaging_material_tracking_mode_lot = /** @type {(inputs: Packaging_Material_Tracking_Mode_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo lô`)
};

/**

* @param {Packaging_Material_Tracking_Mode_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_tracking_mode_lot = /** @type {((inputs?: Packaging_Material_Tracking_Mode_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Tracking_Mode_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_tracking_mode_lot(inputs)
});